import { render, staticRenderFns } from "./ListaOfertas.vue?vue&type=template&id=374f7823&"
import script from "./ListaOfertas.vue?vue&type=script&lang=js&"
export * from "./ListaOfertas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports